// ProgramDays.jsx
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classes from '../FitnessPreview.module.scss'
import DayCard from './DayCard'

const ProgramDays = ({ wellnessDays }) => {
    const CHUNK_SIZE = 7; //7 days / 1 week

    const [weeklyProgram, setWeeklyProgram] = useState([])

    useEffect(() => {
        if (!Array.isArray(wellnessDays) || wellnessDays.length === 0) {
            setWeeklyProgram([])
            return
        }
        const newWeeks = _.chunk(wellnessDays, CHUNK_SIZE);
        setWeeklyProgram(newWeeks)
    }, [wellnessDays])

    if (weeklyProgram.length === 0) {
        return null
    }
    return (

        <div className={classes.programDaysSection}>
            <div className={classes.subheading}>Workouts</div>
            <div className={classes.weeksContainer}>
                {weeklyProgram.map((weekArray, weekIndex) => (
                    <div
                        key={weekIndex}
                        className={
                            weekIndex === 0
                                ? `${classes.weekLabel} ${classes.activeWeekLabel}`
                                : classes.weekLabel
                        }
                    >
                        Week {weekIndex + 1}
                    </div>
                ))}
            </div>

            <div className={classes.dayList}>
                {weeklyProgram[0]?.map((day, dayIndex) => <DayCard key={dayIndex} day={day} index={dayIndex} isRest={day.isRest}/>)}
            </div>
        </div>
    )
}

ProgramDays.propTypes = {
    wellnessDays: PropTypes.arrayOf(
        PropTypes.shape({
            isRest: PropTypes.bool,
            isOptional: PropTypes.bool,
            contentType: PropTypes.string,
            instance: PropTypes.shape({
                name: PropTypes.string,
                duration: PropTypes.string,
                file: PropTypes.shape({
                    link: PropTypes.string,
                    name: PropTypes.string,
                    fileKey: PropTypes.string,
                }),
            }),
        })
    ).isRequired,
}

export default ProgramDays
